(function () {
  'use strict';

  var root = document.documentElement;
  var languageStorageKey = 'jillleenStorefrontLanguage';
  var currencyStorageKey = 'jillleenStorefrontCurrency';
  var validLanguages = ['en', 'zh', 'ja'];
  var validCurrencies = ['CNY', 'USD', 'JPY'];
  var priceRecords = new WeakMap();
  var refreshScheduled = false;

  var translations = {
    language: { en: 'Language', zh: '语言', ja: '言語' },
    currency: { en: 'Currency', zh: '货币', ja: '通貨' },
    close: { en: 'Close', zh: '关闭', ja: '閉じる' },
    nav_home: { en: 'Home', zh: '首页', ja: 'ホーム' },
    nav_new: { en: 'New In', zh: '新品', ja: '新作' },
    nav_eye: { en: 'Eye Makeup', zh: '眼妆', ja: 'アイメイク' },
    nav_highlighter: { en: 'Highlighter', zh: '高光', ja: 'ハイライト' },
    nav_bestsellers: { en: 'Bestsellers', zh: '畅销单品', ja: 'ベストセラー' },
    nav_shop_all: { en: 'Shop All', zh: '全部商品', ja: 'すべて見る' },
    shop_now: { en: 'Shop Now', zh: '立即选购', ja: '今すぐ見る' },
    latest_edit: { en: 'The Latest Edit', zh: '最新系列', ja: '最新コレクション' },
    new_arrivals: { en: 'New Arrivals', zh: '新品上架', ja: '新作' },
    shop_all_new: { en: 'Shop All New Arrivals', zh: '查看全部新品', ja: '新作をすべて見る' },
    shop_by_category: { en: 'Shop by Category', zh: '按品类选购', ja: 'カテゴリーから探す' },
    find_favorite: { en: 'Find Your Next Favorite', zh: '找到你的下一件心头好', ja: '次のお気に入りを見つける' },
    eyes: { en: 'Eyes', zh: '眼妆', ja: 'アイ' },
    lips: { en: 'Lips', zh: '唇妆', ja: 'リップ' },
    face: { en: 'Face', zh: '面部', ja: 'フェイス' },
    explore: { en: 'Explore', zh: '探索', ja: '見る' },
    daily_play: { en: 'Makeup As A Daily Form Of Play.', zh: '彩妆，是每天都可以参与的色彩游戏。', ja: 'メイクを、毎日の遊びに。' },
    daily_play_body: {
      en: 'Color should feel intuitive, expressive and entirely your own. JILL LEEN brings an editorial eye to the everyday ritual.',
      zh: '色彩应该直觉、自由，也完全属于你。JILL LEEN 用编辑视角重新看待每一天的上妆仪式。',
      ja: '色は直感的で、自由で、自分らしいもの。JILL LEENは毎日のメイクにエディトリアルな視点を届けます。'
    },
    color_your_way: { en: 'Color, Your Way', zh: '按你的方式玩色', ja: '自分らしい色で' },
    color_your_way_body: {
      en: 'Wear it softly, layer it boldly, or change the finish entirely.',
      zh: '可以轻柔晕染，也可以大胆叠加，随时改变妆效。',
      ja: '軽やかにも、大胆な重ね塗りにも。仕上がりは自由に変えられます。'
    },
    ritual: { en: 'Made For The Ritual', zh: '为每日上妆而设计', ja: '毎日のルーティンのために' },
    ritual_body: {
      en: 'Thoughtful tools and textures turn routine into a moment of self-expression.',
      zh: '用顺手的工具和质地，让日常上妆成为表达自我的时刻。',
      ja: '使いやすいツールと質感が、いつものメイクを自己表現の時間に変えます。'
    },
    evolving: { en: 'Always Evolving', zh: '持续探索', ja: 'いつも新しく' },
    evolving_body: {
      en: 'New color stories invite you to experiment without changing who you are.',
      zh: '新的色彩灵感，邀请你不断尝试，同时保留真实的自己。',
      ja: '新しいカラーストーリーで、自分らしさを変えずに新しい表現を楽しめます。'
    },
    discover_collection: { en: 'Discover The Collection', zh: '探索系列', ja: 'コレクションを見る' },
    most_loved: { en: 'Most Loved', zh: '人气之选', ja: '人気アイテム' },
    shop_bestsellers: { en: 'Shop Our Bestsellers', zh: '选购畅销单品', ja: 'ベストセラーをチェック' },
    bestseller: { en: 'Bestseller', zh: '畅销', ja: 'ベストセラー' },
    newsletter: { en: 'Newsletter Sign Up', zh: '订阅邮件', ja: 'メールニュース' },
    newsletter_body: {
      en: 'Receive our latest updates about our products and promotions.',
      zh: '及时了解新品与活动。',
      ja: '新作とキャンペーン情報をお届けします。'
    },
    email_placeholder: { en: 'Your Email Address', zh: '邮箱地址', ja: 'メールアドレス' },
    submit: { en: 'Submit', zh: '订阅', ja: '登録' },
    eye_collection: { en: 'Eye makeup', zh: '眼妆', ja: 'アイメイク' },
    highlighter_collection: { en: 'Highlighter', zh: '高光', ja: 'ハイライト' },
    refine_by: { en: 'Refine by', zh: '筛选', ja: '絞り込み' },
    sort_by: { en: 'Sort by', zh: '排序', ja: '並び替え' },
    featured: { en: 'Featured', zh: '精选', ja: 'おすすめ' },
    most_relevant: { en: 'Most relevant', zh: '最相关', ja: '関連度順' },
    best_selling: { en: 'Best selling', zh: '畅销优先', ja: '売れ筋順' },
    alpha_az: { en: 'Alphabetically, A-Z', zh: '名称 A–Z', ja: '名前 A–Z' },
    alpha_za: { en: 'Alphabetically, Z-A', zh: '名称 Z–A', ja: '名前 Z–A' },
    price_low_high: { en: 'Price, low to high', zh: '价格从低到高', ja: '価格の安い順' },
    price_high_low: { en: 'Price, high to low', zh: '价格从高到低', ja: '価格の高い順' },
    date_old_new: { en: 'Date, old to new', zh: '上架时间从早到晚', ja: '古い商品順' },
    date_new_old: { en: 'Date, new to old', zh: '上架时间从晚到早', ja: '新着順' }
  };

  var exactTextKeys = {
    'Close': 'close',
    'Home': 'nav_home',
    'Eye Makeup': 'nav_eye',
    'EYE MAKEUP': 'eye_collection',
    'Eye makeup': 'eye_collection',
    'Highlighter': 'highlighter_collection',
    'HIGHLIGHTER': 'highlighter_collection',
    'Shop Now': 'shop_now',
    'Shop now': 'shop_now',
    'SHOP NOW': 'shop_now',
    'The Latest Edit': 'latest_edit',
    'THE LATEST EDIT': 'latest_edit',
    'New Arrivals': 'new_arrivals',
    'Shop All New Arrivals': 'shop_all_new',
    'Shop all new arrivals': 'shop_all_new',
    'SHOP ALL NEW ARRIVALS': 'shop_all_new',
    'Shop by Category': 'shop_by_category',
    'SHOP BY CATEGORY': 'shop_by_category',
    'Find Your Next Favorite': 'find_favorite',
    'Find your next favorite': 'find_favorite',
    'Eyes': 'eyes',
    'Lips': 'lips',
    'Face': 'face',
    'Explore': 'explore',
    'EXPLORE': 'explore',
    'Makeup As A Daily Form Of Play.': 'daily_play',
    'Makeup as a daily form of play.': 'daily_play',
    'Color should feel intuitive, expressive and entirely your own. JILL LEEN brings an editorial eye to the everyday ritual.': 'daily_play_body',
    'Color, Your Way': 'color_your_way',
    'Color, your way': 'color_your_way',
    'Wear it softly, layer it boldly, or change the finish entirely.': 'color_your_way_body',
    'Made For The Ritual': 'ritual',
    'Made for the ritual': 'ritual',
    'Thoughtful tools and textures turn routine into a moment of self-expression.': 'ritual_body',
    'Always Evolving': 'evolving',
    'Always evolving': 'evolving',
    'New color stories invite you to experiment without changing who you are.': 'evolving_body',
    'Discover The Collection': 'discover_collection',
    'Discover the collection': 'discover_collection',
    'DISCOVER THE COLLECTION': 'discover_collection',
    'Most Loved': 'most_loved',
    'MOST LOVED': 'most_loved',
    'Shop Our Bestsellers': 'shop_bestsellers',
    'Bestseller': 'bestseller',
    'Newsletter Sign Up': 'newsletter',
    'NEWSLETTER SIGN UP': 'newsletter',
    'Receive our latest updates about our products and promotions.': 'newsletter_body',
    'Submit': 'submit',
    'SUBMIT': 'submit',
    'Refine by': 'refine_by',
    'Sort by': 'sort_by',
    'Featured': 'featured',
    'Most relevant': 'most_relevant',
    'Best Selling': 'best_selling',
    'Best selling': 'best_selling',
    'Alphabetically, A-Z': 'alpha_az',
    'Alphabetically, Z-A': 'alpha_za',
    'Price, low to high': 'price_low_high',
    'Price, high to low': 'price_high_low',
    'Date, old to new': 'date_old_new',
    'Date, new to old': 'date_new_old'
  };

  var productTitles = {
    'jill-leen-colorful-soft-mist-blush-3g-matte-pearlescent-face-cheek-brightening-makeup-for-20-30': {
      en: 'Soft Mist Blush', zh: '柔雾腮红', ja: 'ソフトミストチーク'
    },
    'jill-leen-setting-spray-oil-control-hydrating-quick-setting-waterproof-sweat-resistant-moisturizing-long-lasting-makeup-lock': {
      en: 'Hydrating Setting Spray', zh: '水润定妆喷雾', ja: 'モイスチャーセッティングスプレー'
    },
    'jill-leen3-color-contour-palette-matte-shading-nose-contour-side-contour-highlighter-brightening-all-in-one': {
      en: '3-Color Contour Palette', zh: '三色修容盘', ja: '3色コントゥアパレット'
    },
    'jill-leen三色平衡遮瑕膏遮盖斑点-遮瑕黑眼圈痘印脸部提亮': {
      en: '3-Color Balancing Concealer', zh: '三色平衡遮瑕盘', ja: '3色バランシングコンシーラー'
    },
    '精细笔头jill-leen炫色眼线液笔防水-流畅速干抗晕不掉渣新手好画': {
      en: 'Precision Waterproof Liquid Eyeliner', zh: '防水眼线液笔', ja: 'ウォータープルーフ リキッドアイライナー'
    },
    'jill-leen新品九色眼影盘女美瑛珠光提亮-带闪-自然立体彩妆便携': {
      en: '9-Color Shimmer Eyeshadow Palette', zh: '九色珠光眼影盘', ja: '9色シマーアイシャドウパレット'
    },
    'jill-leen炫色迷你眼影盘燕麦哑珠光亮片闪粉-微醺酒红色眼妆修容': {
      en: 'Mini Oat & Wine Eyeshadow Palette', zh: '燕麦酒红迷你眼影盘', ja: 'ミニ オーツ＆ワイン アイシャドウ'
    },
    'jill-leen眼影小盘便携番茄炒蛋哑光风铃郁金香珠光新套装平价女': {
      en: 'Mini Tomato & Tulip Eyeshadow Palette', zh: '番茄郁金香迷你眼影盘', ja: 'ミニ トマト＆チューリップ アイシャドウ'
    },
    'jill-leen迷你九色眼影盘便携黄色绿色蓝色亮片珠光哑光闪粉眼影': {
      en: 'Mini Color Pop Eyeshadow Palette', zh: '炫彩迷你眼影盘', ja: 'ミニ カラーポップ アイシャドウ'
    },
    'jill-leen炫色迷你眼影盘便携-粉棕温柔系裸妆初学者偏光大地色女': {
      en: 'Mini Pink-Brown Eyeshadow Palette', zh: '粉棕迷你眼影盘', ja: 'ミニ ピンクブラウン アイシャドウ'
    },
    'jill-leen十二色眼影盘漂亮盘-哑光奶茶色系日常温柔通勤新品': {
      en: '12-Color Milk Tea Eyeshadow Palette', zh: '十二色奶茶眼影盘', ja: '12色ミルクティー アイシャドウ'
    },
    'jill-leen双色修容粉饼阴影鼻影瘦脸遮瑕哑光提亮立体高光一体盘': {
      en: 'Duo Contour & Highlight Palette', zh: '双色修容高光盘', ja: 'デュオ コントゥア＆ハイライト'
    },
    'jill-leen塑形雾感眉笔女防水不易晕染撕拉眉笔木质硬芯自然持久': {
      en: 'Sculpting Soft-Mist Brow Pencil', zh: '塑形柔雾眉笔', ja: 'ソフトミスト アイブロウペンシル'
    }
  };

  var displayRates = { CNY: 1, USD: 0.148, JPY: 23.4 };
  var priceSelector = [
    '[data-price-grid]',
    '[data-compare-price-grid]',
    '.price-box',
    '.jl-product-edit__price',
    '.jillleen-creator-video-card__price',
    '.jillleen-pdp-price',
    '.productView-price',
    '.cart-price',
    '.cart__price',
    '.total-price',
    '[data-cart-subtotal]'
  ].join(',');

  function readStorage(key, fallback) {
    var value = '';

    try {
      value = window.localStorage.getItem(key) || '';
    } catch (error) {
      // Fall through to the cookie copy below.
    }

    if (!value) {
      var cookie = document.cookie.split('; ').find(function (item) {
        return item.indexOf(key + '=') === 0;
      });
      if (cookie) value = decodeURIComponent(cookie.slice(key.length + 1));
    }

    return value || fallback;
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Private browsing can disable storage; the cookie copy remains available.
    }

    document.cookie = key + '=' + encodeURIComponent(value) + '; max-age=31536000; path=/; SameSite=Lax';
  }

  function currentLanguage() {
    var language = root.dataset.jillleenLanguage || readStorage(languageStorageKey, 'en');
    return validLanguages.indexOf(language) === -1 ? 'en' : language;
  }

  function currentCurrency() {
    var currency = root.dataset.jillleenCurrency || readStorage(currencyStorageKey, 'CNY');
    return validCurrencies.indexOf(currency) === -1 ? 'CNY' : currency;
  }

  function translate(key, language) {
    var entry = translations[key];
    if (!entry) return '';
    return entry[language] || entry.en || '';
  }

  function setElementText(element, value) {
    if (!element || !value || element.textContent === value) return;
    element.textContent = value;
  }

  function applyKeyedTranslations(scope, language) {
    scope.querySelectorAll('[data-jl-i18n]').forEach(function (element) {
      setElementText(element, translate(element.dataset.jlI18n, language));
    });
  }

  function applyNavigationTranslations(scope, language) {
    scope.querySelectorAll('.site-nav > .menu-lv-1 > a').forEach(function (link) {
      var key = link.dataset.jlI18n;

      if (!key) {
        var url;
        try {
          url = new URL(link.getAttribute('href') || '/', window.location.origin);
        } catch (error) {
          return;
        }

        if (url.pathname === '/') key = 'nav_home';
        if (url.pathname.indexOf('/collections/eye-makeup') === 0) key = 'nav_eye';
        if (url.pathname.indexOf('/collections/highlighter') === 0) key = 'nav_highlighter';
      }

      if (!key) return;
      link.dataset.jlI18n = key;
      var textNode = Array.prototype.find.call(link.childNodes, function (node) {
        return node.nodeType === Node.ELEMENT_NODE && node.matches('span:not(.icon-dropdown)');
      });
      setElementText(textNode || link, translate(key, language));
    });
  }

  function applyExactTranslations(scope, language) {
    scope.querySelectorAll('a, button, h1, h2, h3, label, p, span').forEach(function (element) {
      if (element.matches('[data-jl-language], [data-jl-currency]') || element.closest('[data-jl-language], [data-jl-currency]')) return;
      if (element.children.length > 0) return;

      var original = element.dataset.jlOriginalText;
      if (!original) {
        original = element.textContent.trim();
        if (!exactTextKeys[original]) return;
        element.dataset.jlOriginalText = original;
      }

      var key = exactTextKeys[original];
      if (key) setElementText(element, translate(key, language));
    });

    scope.querySelectorAll('input[placeholder]').forEach(function (input) {
      if (!input.dataset.jlOriginalPlaceholder) input.dataset.jlOriginalPlaceholder = input.getAttribute('placeholder') || '';
      if (input.dataset.jlOriginalPlaceholder.toLowerCase() === 'your email address') {
        input.setAttribute('placeholder', translate('email_placeholder', language));
      }
    });

    scope.querySelectorAll('input[type="submit"][value]').forEach(function (input) {
      if (!input.dataset.jlOriginalValue) input.dataset.jlOriginalValue = input.value;
      if (input.dataset.jlOriginalValue.toLowerCase() === 'submit') {
        input.value = translate('submit', language);
      }
    });
  }

  function productHandleForElement(element) {
    var link = element.matches('a[href*="/products/"]') ? element : null;
    var card = element.closest('[data-product-id], .jl-product-edit, .jillleen-creator-video-card');

    if (!link && card) link = card.querySelector('a[href*="/products/"]');
    if (!link) link = element.closest('a[href*="/products/"]');
    if (!link && window.location.pathname.indexOf('/products/') === 0) {
      try {
        return decodeURIComponent(window.location.pathname.split('/products/')[1].split('/')[0]);
      } catch (error) {
        return '';
      }
    }
    if (!link) return '';

    try {
      var pathname = new URL(link.getAttribute('href'), window.location.origin).pathname;
      var encodedHandle = pathname.split('/products/')[1];
      return encodedHandle ? decodeURIComponent(encodedHandle.split('/')[0]) : '';
    } catch (error) {
      return '';
    }
  }

  function applyProductTranslations(scope, language) {
    var selectors = [
      'a.product-title',
      '.jl-product-edit__details h3 a',
      '.jillleen-creator-video-card__name',
      '.jillleen-pdp-title'
    ].join(',');

    scope.querySelectorAll(selectors).forEach(function (element) {
      var handle = productHandleForElement(element);
      var title = productTitles[handle];
      if (!title) return;

      var translatedTitle = title[language] || title.en;
      var textNode = Array.prototype.find.call(element.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE && node.nodeValue.trim();
      });

      if (textNode) {
        if (textNode.nodeValue.trim() !== translatedTitle) {
          textNode.nodeValue = textNode.nodeValue.replace(textNode.nodeValue.trim(), translatedTitle);
        }
      } else if (element.children.length === 0) {
        setElementText(element, translatedTitle);
      }
    });
  }

  function formatPrice(baseAmount, currency) {
    var converted = baseAmount * displayRates[currency];
    if (currency === 'USD') return '$' + converted.toFixed(2);
    if (currency === 'JPY') return 'JP¥' + Math.round(converted).toLocaleString('ja-JP');
    return 'CN¥' + converted.toFixed(2);
  }

  function updatePriceTextNode(node, currency) {
    var record = priceRecords.get(node);

    if (record && node.nodeValue !== record.rendered) record = null;

    if (!record) {
      var original = node.nodeValue;
      var match = original.match(/(?:CN)?[¥￥]\s*([0-9][0-9,]*(?:\.[0-9]+)?)/);
      if (!match) return;

      var baseAmount = Number(match[1].replace(/,/g, ''));
      if (!Number.isFinite(baseAmount)) return;

      record = { original: original, baseAmount: baseAmount, rendered: original };
      priceRecords.set(node, record);
    }

    var renderedPrice = formatPrice(record.baseAmount, currency);
    var rendered = record.original.replace(/(?:CN)?[¥￥]\s*[0-9][0-9,]*(?:\.[0-9]+)?/, renderedPrice);
    record.rendered = rendered;
    if (node.nodeValue !== rendered) node.nodeValue = rendered;
  }

  function applyCurrency(scope, currency) {
    scope.querySelectorAll(priceSelector).forEach(function (container) {
      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) updatePriceTextNode(node, currency);
    });
  }

  function currencyNote(language, currency) {
    if (language === 'zh') return '当前按近似汇率显示 ' + currency + '，结账仍以人民币 CNY 为准。';
    if (language === 'ja') return '概算レートで ' + currency + ' 表示。決済はCNYのままです。';
    return 'Approximate ' + currency + ' display. Checkout remains CNY.';
  }

  function languageNote(language) {
    if (language === 'zh') return '当前为官网主要界面的预览翻译；结账语言仍由 Shopify 管理。';
    if (language === 'ja') return 'ストア主要画面のプレビュー翻訳です。決済言語はShopifyで管理されます。';
    return 'Storefront interface preview. Checkout language remains managed by Shopify.';
  }

  function updateControls(language, currency) {
    document.querySelectorAll('[data-jl-language]').forEach(function (button) {
      var active = button.dataset.jlLanguage === language;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    document.querySelectorAll('[data-jl-currency]').forEach(function (button) {
      var active = button.dataset.jlCurrency === currency;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    document.querySelectorAll('[data-jl-header-language]').forEach(function (element) {
      setElementText(element, language === 'zh' ? '中' : language === 'ja' ? '日' : 'EN');
    });

    document.querySelectorAll('[data-jl-header-currency]').forEach(function (element) {
      setElementText(element, currency);
    });

    document.querySelectorAll('[data-jl-language-note]').forEach(function (element) {
      setElementText(element, languageNote(language));
    });

    document.querySelectorAll('[data-jl-currency-note]').forEach(function (element) {
      setElementText(element, currencyNote(language, currency));
    });
  }

  function applyStorefront(scope) {
    var language = currentLanguage();
    var currency = currentCurrency();
    var target = scope && scope.querySelectorAll ? scope : document;

    applyKeyedTranslations(target, language);
    applyNavigationTranslations(target, language);
    applyExactTranslations(target, language);
    applyProductTranslations(target, language);
    applyCurrency(target, currency);
    updateControls(language, currency);
  }

  function setLanguage(language) {
    if (validLanguages.indexOf(language) === -1) return;
    root.dataset.jillleenLanguage = language;
    root.lang = language === 'zh' ? 'zh-CN' : language;
    writeStorage(languageStorageKey, language);
    applyStorefront(document);
  }

  function setCurrency(currency) {
    if (validCurrencies.indexOf(currency) === -1) return;
    root.dataset.jillleenCurrency = currency;
    writeStorage(currencyStorageKey, currency);
    applyStorefront(document);
  }

  function setupControls() {
    document.addEventListener('click', function (event) {
      var languageButton = event.target.closest('[data-jl-language]');
      if (languageButton) {
        event.preventDefault();
        setLanguage(languageButton.dataset.jlLanguage);
        return;
      }

      var currencyButton = event.target.closest('[data-jl-currency]');
      if (currencyButton) {
        event.preventDefault();
        setCurrency(currencyButton.dataset.jlCurrency);
      }
    });
  }

  function setupPageTransition() {
    root.classList.add('jillleen-page-transition-ready');

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
      var rawHref = (link.getAttribute('href') || '').trim();
      if (!rawHref || rawHref === '#' || rawHref.charAt(0) === '#' || rawHref.indexOf('javascript:') === 0) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;

      root.classList.add('jillleen-page-leaving');
      window.setTimeout(function () {
        root.classList.remove('jillleen-page-leaving');
      }, 1600);
    }, true);

    window.addEventListener('pageshow', function () {
      root.classList.remove('jillleen-page-leaving');
    });
  }

  function setupObserver() {
    var observer = new MutationObserver(function () {
      if (refreshScheduled) return;
      refreshScheduled = true;
      window.requestAnimationFrame(function () {
        refreshScheduled = false;
        applyStorefront(document);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    try {
      setupControls();
      setupPageTransition();
      applyStorefront(document);
      setupObserver();
    } finally {
      root.classList.remove('jillleen-localization-pending');
      root.classList.add('jillleen-localization-ready');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
